import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { SetupRedirectBannerComponent } from '@main-client/src/app/setup-redirect-banner/setup-redirect-banner.component';

@NgModule({
  imports: [CommonModule, FlexLayoutModule, MatIconModule, RouterModule],
  declarations: [SetupRedirectBannerComponent],
  exports: [SetupRedirectBannerComponent],
})
export class SetupRedirectBannerModule {}
